import axios from "axios";

// Empty/unset REACT_APP_BACKEND_URL = same origin (the docker-compose setup proxies /api to the backend).
const API = `${process.env.REACT_APP_BACKEND_URL ?? ""}/api`;

// The session lives in an httpOnly cookie (not readable by scripts); the custom header is the CSRF guard.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => { onUnauthorized = fn; };

// An expired or invalid session on any protected call sends the user back to the login screen.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error?.config?.url || "";
    if (error?.response?.status === 401 && !url.startsWith("/auth/") && onUnauthorized) onUnauthorized();
    return Promise.reject(error);
  }
);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Κάτι πήγε στραβά";
};

export default api;
